import DcPostGrid from '../layout/DcPostGrid';
// import DcPostGrid from '@dc-post-grid/layout/DcPostGrid'; // Plugin files

const dcPostGrids = document.querySelectorAll('.dc-post-grid-component-wrapper');
if (dcPostGrids.length) {
	for (let i = 0; i < dcPostGrids.length; i++) {
		const dcPostGridId = dcPostGrids[i].id;
		const dcPostGridBlockId = dcPostGridId.replace('dc_post_grid_', '');
		const dcPostGridData = dcpgData[dcPostGridBlockId];
		new Vue({
			render: (h) =>
				h(DcPostGrid, {
					props: dcPostGridData,
				}),
		}).$mount('#' + dcPostGridId);
	}
}
